import { createContext } from "react";

type IAlertDialogFunction = (props: {
  title?: string;
  message: string;
}) => void;

export type IConfirmDialogFunction = (props: {
  title: string;
  message: string;
  confirmLabel?: string;
}) => Promise<boolean>;

type DialogContextProps = {
  alert: IAlertDialogFunction;
  confirm: IConfirmDialogFunction;
};

export const DialogContext = createContext<DialogContextProps>({
  alert: () => {},
  confirm: async () => false,
});
